import { getCookie } from 'apps-common'

export const isNewLearnerMF = () => {
  return getCookie('new-learner-MF') === 'true'
}
